import image1 from '@/assets/images/news/detail/20200910/1.jpg';
import image2 from '@/assets/images/news/detail/20200910/2.png';
import image3 from '@/assets/images/news/detail/20200910/3.jpg';
import image4 from '@/assets/images/news/detail/20200910/4.jpg';
import image5 from '@/assets/images/news/detail/20200910/5.jpg';
import image6 from '@/assets/images/news/detail/20200910/6.png';

export default {
  id: '20200910', //  模块 id
  title: '让我成为你的眼', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '今年是叮咚买菜第三年携手微笑明天慈善基金会，开展“你捐一份、叮咚捐一份”的公益活动，短短的3天时间里，吸引了许多有爱心的小伙伴参与进来，他们用爱为视障人群点亮一片天空。虽然99公益日圆满落下了帷幕，可我们的爱心行动永不停歇。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1, image2],
    },
    {
      type: 1,
      title: '',
      src: [image3, image4],
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '为了帮助视障人群解决买菜难的困扰，叮咚买菜app还推出“盲人模式”，视障人士可通过触摸手机屏幕，软件就会播报菜名、价格、购买步骤等对应信息，用耳朵就能买菜。对于这些特殊人群，我们的技术中心团队会定期走访，接受用户的一线反馈，持续改进前端平台系统，从而不断优化无障碍操作系统的使用体验。用实际行动去践行我们的使命——让美好的食材像自来水一样，触手可得，普惠万众。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '对于视障群体，我们不只是一群简单的“送菜小哥”，更是生活中不可或缺的陪走伙伴。关爱视障人群，让爱持续发酵，让我成为你的眼。',
      isIndent: false,
    },
    {
      type: 1,
      title: ['叮咚买菜公共关系组实地采访｜视障老人用耳朵买菜'],
      src: [image6],
    },
  ],
};
